export var REQUEST_TIMEOUT = 20000;
export var ZIPCODE_LENGTH = 5;
export var MAX_ALTERNATE_PHONES = 3;
export var OTP_CODE_LENGTH = 6;
export var MANAGE_USERS_PAGE_SIZE = 21;
export var BULK_ADD_USERS_PAGE_SIZE = 10;
export var BULK_ADD_MAX_USERS_LENGTH = 500;
export var BULK_ADD_MAX_ERROR_FIELDS = 20;
